const state = {
  parameters: [],
  parameterUpdatedMessage: '',
  priceConverters: []
};
const mutations = {
  SET_PARAMETERS(state, parameters) {
    state.parameters = parameters
  },
  UPDATE_PARAMETER_SUCCESS(state, payload) {
    state.parameterUpdatedMessage = payload;
    setTimeout(() => (state.parameterUpdatedMessage = ""), 3000);
  },
  SET_PRICE_CONVERTERS(state, priceConverters) {
    state.priceConverters = priceConverters
  }
};
const getters = {
  getParameters: (state) => {
    return state.parameters
  },
  getParameterUpdatedMessage: (state) => {
    return state.parameterUpdatedMessage;
  },
  getPriceConventers: (state) => {
    return state.priceConverters;
  }
};

export default {
  state,
  mutations,
  getters,
};